import React from 'react';
import Section from "./Section/Section";
import {LIST} from "./data/list";
import RandomTip from "./RandomTip/RandomTip";
import EmailCTA from "./EmailCTA/EmailCTA";
import ShareBar from "./ShareBar/ShareBar";
import CTABanner from "./CTABanner/CTABanner";

import './App.css';

function App() {
  return (
    <div className="App">
      <ShareBar />
      <RandomTip/>
      {LIST.map((i, index) =>
        <React.Fragment>
          {[1, 4].includes(index) && <div className="text-center mb-5">
            <h6 style={{opacity: 0.7}}>Brought to you by</h6>
            <div className="p-3">
              <CTABanner />
            </div>
          </div>}
          <Section key={index} header={i.header} list={i.list}/>
        </React.Fragment>
      )}
      <div id="sign-up" className="container pt-15">
        <div className="row">
          <div className="mt-3 mb-5 m-auto">
            <div className="col-10 m-auto col-lg-8 description">
              <h4>How to use this list</h4>
              <p className="mt-3 font-18">
                There's no silver bullet here, this is not an easy list to execute. Whilst you
                may not be comfortable executing every single idea here, a few will stand out. Begin with those and develop them
                as habits into your workday.</p>
            </div>
          </div>
        </div>
      </div>
      <EmailCTA />
    </div>
  );
}

export default App;
